export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const API_KEY = '9107fc68-8141-43ff-af46-fa3ef2cd1c20';
export const MODAL_CLOSE_SEC = 2.5;
